export const site = {
  name: '糖心吃瓜网',
  slogan: '饭点随手一刷，笑到喷饭',
  description:
    '糖心吃瓜网专注于收集打工人的快乐碎片，热瓜、段子、沙雕图、下饭视频一网打尽，专治无聊空虚。',
  email: 'hello@tangxin-chigua.example.com',
  icp: '',
};

export const stats = [
  { label: '今日上新', value: '128', unit: '条' },
  { label: '吃瓜群众', value: '86', unit: '万' },
  { label: '累计笑料', value: '2.4', unit: '万' },
  { label: '每日摸鱼时长', value: '16', unit: '分钟' },
];

export const faqs = [
  {
    q: '糖心吃瓜网每天更新多少内容？',
    a: '我们每天固定更新热瓜、下饭专区、摸鱼段子与沙雕图鉴等栏目，平均每天 100 条以上，饭点和深夜会各有一波集中上新。',
  },
  {
    q: '内容都是原创的吗？',
    a: '站内短文与观察类内容由编辑整理改写，图片与短视频为网友投稿或已获授权转载。如果你发现内容涉及侵权，可以通过页面底部的邮箱联系我们，我们会尽快处理。',
  },
  {
    q: '投稿怎么投？有稿费吗？',
    a: '可以通过联系我们页面的表单提交你的瓜或笑料，被采用后会署名展示。优质投稿我们会提供小额稿费，具体以回复为准。',
  },
  {
    q: '为什么有的瓜没有后续？',
    a: '热点事件往往还在发酵中，我们会在有新进展时更新补充说明，也会在原帖标注更新时间，避免大家吃到半截瓜。',
  },
  {
    q: '可以在手机上看吗？',
    a: '可以。全站做了移动端适配，手机、平板、电脑都能顺畅浏览，摸鱼时打开也不占流量。',
  },
  {
    q: '如何第一时间看到更新？',
    a: '在首页底部订阅我们的每日精选，我们会把当天最好笑的内容整理成一封简讯发给你，绝不打扰。',
  },
];

export const testimonials = [
  {
    name: '小陈',
    role: '互联网搬砖工',
    text: '午休打开糖心吃瓜网，一顿饭能吃四十分钟，笑点密度比外卖还高。',
  },
  {
    name: '阿May',
    role: '设计系学生',
    text: '沙雕图鉴那一栏救了我的期末周，画不出来的时候刷两条，脑子就活了。',
  },
  {
    name: '老周',
    role: '出租车司机',
    text: '跑夜班等客的间隙看两条，时间过得快，也不那么困了。',
  },
  {
    name: '柚子',
    role: '人力资源',
    text: '内容挺有分寸，笑归笑，没有那种让人不舒服的刻薄，这点很难得。',
  },
];

export const contentPrinciples = [
  {
    icon: 'ri-heart-3-line',
    title: '好笑但不刻薄',
    desc: '我们喜欢让人会心一笑的内容，不靠嘲讽特定群体制造笑点。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '有谱但不端着',
    desc: '热点瓜讲究信息来源和时间线，该标注的更新节点绝不含糊。',
  },
  {
    icon: 'ri-sparkling-line',
    title: '短小但不敷衍',
    desc: '两分钟能读完的篇幅，也要写清楚前因后果，不糊弄读者。',
  },
  {
    icon: 'ri-leaf-line',
    title: '陪伴但不打扰',
    desc: '不做扰民推送，订阅是你主动要的，我们才发。',
  },
];